import { REQUIRED_CREDITS } from '../constants/credits';

const sl = {
  inputType: 'Vrsta vnosa:',
  uploadPDF: 'PDF',
  comicDescription: 'Opiši strip',
  comicDescriptionPlaceholder:
    'Radoveden slon se nauči leteti s pomočjo prijateljev iz džungle.',
  comicDescriptionErrorMessage: 'Opis mora biti vsaj 10 znakov dolg. ☝️',
  color: 'Barva:',
  colorVariant: 'Izberite barvno različico',
  generatingDialog: 'Ustvarjanje dialoga ...',
  generatePDF: 'Ustvari PDF',
  generatingPDF: 'Ustvarjanje PDF-ja ...',
  generatedPDF: 'Ustvarjen PDF',
  message: 'Sporočilo',
  language: 'Strip zelim v jeziku:',
  languageSerbian: 'Srbščina',
  languageSlovenian: 'Slovenski',
  languageEnglish: 'Angleščina',
  languageSpanish: 'Španščina',
  languageFrench: 'Francoščina',
  languageRussian: 'Ruščina',
  languageItalian: 'Italijanščina',
  languageChinese: 'Kitajščina',
  languageTurkish: 'Turščina',
  languageHungarian: 'Madžarščina',
  languagePortuguese: 'Portugalščina',
  page: 'Stran:',
  editProfile: 'Uredi profil',
  purchaseTokens: 'Kupi tokene',
  transactions: 'Transakcije',
  help: 'Pomoč',
  transactionHistory: 'Zgodovina transakcij tokenov',
  couldNotLoadTransactions: 'Transakcij ni bilo mogoče naložiti.',
  noTransactions: 'Transakcij še ni.',
  transactionDate: 'Datum',
  transactionSource: 'Vir',
  transactionAmount: 'Znesek',
  transactionStatus: 'Status',
  rowsPerPage: 'Vrstic na stran',
  previous: 'Prejšnja',
  next: 'Naslednja',
  pageOf: 'Stran __PAGE__ od __TOTAL__',
  statusCompleted: 'Zaključeno',
  sourcePurchase: 'Nakup',
  sourceCoupon: 'Kupon',
  sourceRefund: 'Vračilo',
  sourceDailyGift: 'Dnevno darilo',
  sourceScicomic: 'SciComic',
  sourceCite: 'Cite',
  helpGetStartedTitle: 'Kako začeti',
  helpGetStartedStep1:
    'Izberi, ali želiš naložiti PDF ali opisati idejo za strip.',
  helpGetStartedStep2:
    'Pred ustvarjanjem dialoga nastavi jezik in število strani.',
  helpGetStartedStep3:
    'Preglej ustvarjeno besedilo, po potrebi popravi sporočila in nato ustvari končni PDF.',
  helpWritingTitle: 'Nasveti za boljši rezultat',
  helpWritingTip1:
    'Opis naj bo kratek, jasen in osredotočen na eno glavno idejo ali prizor.',
  helpWritingTip2: 'Za natančnejši rezultat omeni ton, like in okolje.',
  helpWritingTip3: 'Pred izvozom lahko ročno popraviš besedilo v oblačkih.',
  helpGenerationTitle: 'Nasveti za ustvarjanje',
  helpGenerationTip1:
    'Ustvarjanje dialoga in stripa porablja tokene, zato najprej preveri stanje.',
  helpGenerationTip2:
    'Pri enostranskih stripih uporabi krajše besedilo, da ostane vse berljivo.',
  helpGenerationTip3:
    'Če rezultat ni pravi, znova ustvari dialog ali popravi besedilo pred ustvarjanjem PDF-ja.',
  helpContactTitle: 'Potrebuješ še pomoč?',
  helpContactDescription:
    'Če naletiš na težavo ali potrebuješ pomoč glede računa ali tokenov, se obrni na našo podporo.',
  helpGotIt: 'Razumem',
  helpVersion: 'SciComic v1.0',
  selectTokenPackage: 'Izberite paket tokenov',
  individual: 'Posameznik',
  professional: 'Profesionalni',
  closePurchaseModal: 'Zapri nakup tokenov',
  stripeConfigurationError: 'Nakup tokenov trenutno ni na voljo.',
  redeemCode: 'Unovči kodo',
  enterCode: 'Vnesite kodo',
  redeem: 'Unovči',
  redeeming: 'Unovčevanje...',
  cancel: 'Prekliči',
  codeRedeemed: 'Koda je bila uspešno unovčena.',
  codeAlreadyUsed: 'Ta koda je bila že uporabljena.',
  codeNotFound: 'Kode ni bilo mogoče najti.',
  failedToRedeem: 'Kode ni bilo mogoče unovčiti.',
  wizardStep: 'Korak',
  wizardSource: 'Vir in nastavitve',
  wizardScript: 'Scenarij',
  wizardImages: 'Slike kadrov',
  wizardVisualDesign: 'Pripravljeno za ustvarjanje',
  wizardSourceDescription:
    'Dodajte gradivo za strip ter preverite izbrani jezik.',
  wizardScriptDescription:
    'Pred nadaljevanjem preglejte uvod, kljucna dejstva in zakljucek.',
  wizardImagesDescription:
    'Po zelji nalozite svoje slike ali opisite, kaj naj se ustvari za vsak kader.',
  wizardVisualDescription:
    'Izberite barvo ozadja stripa in citljivo barvo besedila.',
  sourceQuestion: 'Kaj zelite spremeniti v strip?',
  dropPdf: 'Povlecite PDF sem ali kliknite za',
  browsePdf: 'izbiro datoteke',
  continue: 'Nadaljuj',
  comicType: 'Vrsta stripa',
  onePage: 'Ena stran',
  classicFourPanelTemplate: 'Klasicni strip s stirimi kadri',
  classicFourPanelTemplateDescription:
    'Cista postavitev na eni strani z naslovom, stirimi enakimi slikami in besedilom pod vsako sliko.',
  templateTitlePlacement: 'Naslov je na vrhu strani.',
  templateImagePlacement: 'Slike so razporejene v mrezi 2 x 2.',
  templateTextPlacement: 'Besedilo je pod vsako sliko, ne cez sliko.',
  fourPanelStory: 'Zgodba v štirih kadrih',
  verificationScoreLabel: 'Zanesljivost __SCORE__/100',
  verificationDetailsTitle: 'Preverjanje točnosti scenarija',
  verificationDetailsDescription:
    'SciComic verification loop je preveril ustvarjeno zgodbo glede na izvirno besedilo iz PDF-a.',
  verificationDetailSource:
    'Preverjeno je, da številke in ključni podatki v stripu dejansko izvirajo iz izvirnega PDF vira.',
  verificationDetailSourceTooltip:
    'Številke, statistike in kratice v scenariju se primerjajo z izvirnim besedilom vira, da se odkrije, ali strip navaja podatek, ki ga v viru ni.',
  verificationDetailClaims:
    'Ključne trditve v vseh štirih kadrih so pregledane, da ostanejo zveste viru.',
  verificationDetailClaimsTooltip:
    'UI preveri, ali so trditve v vseh štirih kadrih zveste izvirnemu gradivu in da strip ne navaja nečesa, česar vir ne podpira.',
  verificationDetailLanguage: 'Scenarij je preverjen glede izbranega jezika.',
  verificationDetailLanguageTooltip:
    'Preverja se, ali je celotno besedilo dosledno napisano v izbranem jeziku.',
  verificationScoreUnavailableLabel: 'Zanesljivost ni na voljo',
  verificationDetailUnavailable: 'Ni preverjeno',
  verificationDetailUnavailableTooltip:
    'Te preverbe za ta scenarij ni bilo mogoče izvesti, zato ni vključena v skupno zanesljivost in se ne šteje kot uspešna.',
  comicTitle: 'Naslov stripa',
  comicTitlePlaceholder: 'Vnesite naslov za ta strip...',
  defaultComicTitle: 'SciComic',
  panelIntroduction: 'Uvod',
  panelKeyFact: 'Ključno dejstvo',
  panelExplanation: 'Razlaga',
  panelConclusion: 'Zaključek',
  panelTextPlaceholder: 'Napisite en kratek in tocen stavek...',
  panelImage: 'Slika kadra',
  uploadPanelImage: 'Nalozi sliko',
  removePanelImage: 'Odstrani',
  generatedPanelImage: 'Ustvarjena slika',
  panelImagePrompt: 'Poziv za sliko',
  panelImagePromptPlaceholder: 'Opisite sliko, ki jo zelite za ta kader...',
  panelImagePromptDisabled: 'Slika je naložena, poziv ne bo uporabljen.',
  panelImageOptionalNote:
    'Nalozena slika ima prednost. Ce slike ni, SciComic uporabi vas poziv; ce je poziv prazen, sliko ustvari iz zgodbe kadra.',
  previousStep: 'Prejšnji korak',
  createScript: 'Ustvari scenarij',
  workflowError: 'Prišlo je do napake. Poskusite znova.',
  frames: 'kadrov',
  frame: 'Kader',
  emptyFrame: 'Prazen kader',
  sentence: 'Stavek',
  length: 'Dolžina',
  keep: 'Ohrani',
  shorter: 'Krajše',
  longer: 'Daljše',
  complexity: 'Zahtevnost',
  simpler: 'Preprosteje',
  scientific: 'Bolj znanstveno',
  tone: 'Ton',
  toneProfessional: 'Profesionalen',
  toneFriendly: 'Prijazen',
  toneFunny: 'Zabaven',
  rewriteInstruction: 'Navodilo za ponovno ustvarjanje',
  regenerateSourceDescription: 'Opis stripa',
  selectedPdf: 'Izbrani PDF',
  noPdfSelected: 'PDF ni izbran',
  changePdf: 'Spremeni PDF',
  changePdfDescription:
    'Če spremenite PDF, morate scenarij znova ustvariti iz nove datoteke.',
  rewriteInstructionPlaceholder: 'Opišite, kaj naj se v tem kadru spremeni...',
  regenerateFrame: 'Znova ustvari kader',
  comicBackgroundColor: 'Barva ozadja stripa',
  comicBackgroundColorDescription:
    'Nastavite barvo strani za naslovom, slikami in besedilom.',
  comicTextColor: 'Barva besedila',
  comicTextColorDescription:
    'Izberite barvo naslova in napisov. Predlog izboljsa kontrast.',
  comicFonts: 'Pisave stripa',
  comicFontsDescription:
    'Izberite loceno pisavo za naslov in besedilo pod slikami. Sprememba pisave je brezplacna.',
  comicTitleFont: 'Pisava naslova',
  comicBodyFont: 'Pisava besedila pod slikami',
  hexColor: 'HEX barva',
  useSuggestedTextColor: 'Uporabi predlagano barvo besedila',
  storyteller: 'Pripovedovalec',
  logout: 'Odjava',
  spendingCreditsDialog: `Ustvarjanje zgodbe vas bo stalo ${REQUIRED_CREDITS.GENERATE_DIALOG} token.`,
  imageCountText: {
    1: 'eno sliko',
    2: 'dve sliki',
    3: 'tri slike',
    4: 'štiri slike',
  },
  tokenCountText: {
    1: 'en token',
    2: 'dva tokena',
    3: 'tri tokene',
    4: 'štiri tokene',
  },
  imageStepCreditNotice:
    'SciComic bo trenutno ustvaril __IMAGE_COUNT__. To bo stalo __TOKEN_COUNT__ sele ob koncnem ustvarjanju.',
  imageStepFreeNotice:
    'Vse slike so ze na voljo. Zanje ne bodo porabljeni dodatni tokeni.',
  regenerateFrameCreditNotice:
    'Ponovno ustvarjanje tega kadra porabi __CREDITS__ token.',
  notEnoughCreditsDialog: `Potrebujete vsaj ${REQUIRED_CREDITS.GENERATE_DIALOG} kredit za ustvarjanje stripovskega dialoga.`,
  notEnoughCreditsComic:
    'Potrebujete vsaj __TOKEN_COUNT__ za ustvarjanje __IMAGE_COUNT__.',
  disclaimer: 'SciComic lahko dela napake. Preveri pomembne informacije.',
};

export default sl;
